import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { ShareLink } from '#src/app/shared/hooks/share';

import type {
	PetitionGuidesArticleShareLinksQuery,
	PetitionGuidesArticleShareLinksQueryVariables,
} from './api.graphql';
import { PetitionGuidesArticleShareLinks } from './api.graphql';

export async function getPetitionGuidesArticleShareLinks(
	{ slug }: { slug: string },
	{ gql }: UtilityContext,
): Promise<readonly ShareLink[]> {
	const { data } = await gql.fetch<PetitionGuidesArticleShareLinksQuery, PetitionGuidesArticleShareLinksQueryVariables>(
		{
			query: PetitionGuidesArticleShareLinks,
			variables: { slug },
			rejectOnError: true,
		},
	);
	return data.article?.shareLinks.links ?? [];
}
